/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import styles from "./LandingPage.module.css";
import { useHistory, useLocation } from "react-router-dom";
import { useAssessment } from "./AssessmentContext";
import VoiceService from "../voice-agent/VH-Myra-FrontEnd";
import checkBrowserSupport from "./browserDetect";
import { HOME_VIDEO_2 } from "./CONSTANTS";
import { MYRA_AB_SPLIT } from "./CONSTANTS";
import MyraChatService from "../voice-agent/MyraChatService";
// These remain in SelfAssesment.jsx — import from there
import { AnalyticsService, usePreventNavigation } from "./SelfAssesment";
// BrowserBlockScreen is used by both landing and GSA, stays in SelfAssesment.jsx
import { BrowserBlockScreen } from "./SelfAssesment";
import MyraInteraction from "./MyraInteractionController";

// ============================================================
// LOGO URL
// ============================================================
const LOGO_URL = "https://virdiodev.s3.us-east-2.amazonaws.com/sampleVideo/LogoPNG.png";

// ============================================================
// useScrollToTop — local copy (simple utility)
// ============================================================
const useScrollToTop = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);
};

// ============================================================
// LandingPageModal — Microphone permission modal
// ============================================================
export const LandingPageModal = ({ message, onCancel, onGrant, setIsMicModalActive, access = true, setAccess, setMicModalMsg }) => {
  const handleOk = () => {
    setIsMicModalActive(false);
    setMicModalMsg("To chat with Myra, please grant microphone access. Your audio is processed in real-time and never stored or recorded.");
    setAccess(true);
    let msg = "No problem! We can chat instead. I'm here if you need anything — just type or use the buttons on screen.";
    window.mayraCode.setIsVisible(true);
    MyraInteraction.switchMode("chat");
    MyraInteraction.openChat();
    MyraInteraction.pickChat();
    MyraInteraction.onMyraMessage(msg);
  };
  return (
    <div id="myra-alert-overlay" className={styles.myraAlertOverlay}>
      <div className={styles.myraAlertModal}>
        <div className={styles.myraAlertIcon}>
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" width="32" height="32">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 11a7 7 0 01-7 7m0 0a7 7 0 01-7-7m7 7v4m0 0H8m4 0h4m-4-8a3 3 0 01-3-3V5a3 3 0 116 0v6a3 3 0 01-3 3z" />
          </svg>
        </div>
        <p id="myra-alert-message" className={styles.myraAlertMessage}>
          {message}
        </p>
        <div id="myra-alert-buttons" className={styles.myraAlertButtons}>
          {access && (
            <button id="myra-alert-secondary" className={styles.myraAlertBtnSecondary} onClick={onCancel}>
              Cancel
            </button>
          )}
          {access ? (
            <button id="myra-alert-primary" className={styles.myraAlertBtnPrimary} onClick={onGrant}>
              Grant Access
            </button>
          ) : (
            <button id="myra-alert-primary" className={styles.myraAlertBtnPrimary} onClick={handleOk}>
              Ok
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
const trackAnalytics = (newFields) => {
  if (AnalyticsService?.trackStep) {
    try {
      const existingData = JSON.parse(localStorage.getItem("assessmentData")) || {};

      const updatedData = {
        ...existingData,
        ...newFields,
        session_last_update: new Date().toISOString(),
      };

      localStorage.setItem("assessmentData", JSON.stringify(updatedData));
      AnalyticsService.trackStep(updatedData);
    } catch (err) {
      console.error("Analytics error:", err);
    }
  }
};

// ============================================================
// CustomHeader — Simplified nav bar
// ============================================================
const CustomHeader = ({ isStartedLandingFlow, setShowMemberBlockScreen }) => {
  const history = useHistory();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleButtonClick = () => {
    const check = checkBrowserSupport("member");
    if (!check.isSupported) {
      setShowMemberBlockScreen(true);
      return;
    }
    trackAnalytics({
      userMoveBetweenSubPage: true,
    });

    if (isStartedLandingFlow) {
      if (window.mayraCode) {
        window.mayraCode.setIsVisible(false);
        window.mayraCode.forceStop();
        VoiceService.destroyMyraCompletely(false);
        window.mayraCode = null;
        window.startFlow = null;
        window.currentCommandsAudio = {};
      }
      sessionStorage.removeItem("voiceService_wasListening");
      sessionStorage.removeItem("voiceService_currentFlow");
    }

    if (window.preloadAllAudios) window.preloadAllAudios();
    if (window.videoUnlockPlay) window.videoUnlockPlay();
    window.isThisFromHomeScreen = false;

    setTimeout(() => {
      if (!window.isFlutterLoaded) {
        const loader = document.getElementById("flutter-loader");
        if (loader) loader.style.display = "flex";
        const loaderText = loader?.querySelector("#loader-text");
        if (loaderText) loaderText.textContent = "Loading application...";
      }
      const flutterRoot = document.getElementById("OnDemandPlayingRoot");
      if (flutterRoot) flutterRoot.style.display = "block";
      const currentAssessmentRoot = document.getElementById("assesmentDiv");
      if (currentAssessmentRoot) currentAssessmentRoot.style.display = "none";
      localStorage.removeItem("loadSelf");
      localStorage.removeItem("startedSelf");
      window.doNextLocation = history;
      document.querySelector("html").classList = [];
      setTimeout(() => {
        window.setHideElementsElm(true);
      }, 2000);
    }, 100);
  };

  return (
    <header className={styles.customHeader}>
      <div className={styles.customContainer}>
        <div className={styles.logoContainer}>
          <a href="https://www.virdiohealth.com" target="_blank" rel="noopener noreferrer" title="Virdio Health">
            <img
              className={styles.logoImage}
              src={LOGO_URL}
              alt="Virdio Health Logo"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "https://placehold.co/128x32/e2e8f0/475569?text=Logo";
              }}
            />
          </a>
        </div>
        <nav className={`${styles.navLinks} ${isMenuOpen ? styles.open : ""}`}>
          <button
            className={styles.navLink}
            onClick={() => {
              trackAnalytics({
                visitedHowItWorks: true,
                userMoveBetweenSubPage: true,
              });
              history.push("/how-it-works");
              setIsMenuOpen(false);
            }}
          >
            How It Works
          </button>

          <button
            className={styles.navLink}
            onClick={() => {
              trackAnalytics({
                visitedAskMyra: true,
                userMoveBetweenSubPage: true,
              });
              history.push("/ask-myra");
              setIsMenuOpen(false);
            }}
          >
            Ask Myra
          </button>

          <button
            className={styles.navLink}
            onClick={() => {
              trackAnalytics({
                visitedAbout: true,
                userMoveBetweenSubPage: true,
              });
              history.push("/about");
              setIsMenuOpen(false);
            }}
          >
            About Us
          </button>
        </nav>
        <div className={styles.loginButtonContainer}>
          <button className={styles.loginButton} onClick={handleButtonClick}>
            Member Login
          </button>
        </div>
        <button className={styles.menuToggle} onClick={() => setIsMenuOpen(!isMenuOpen)}>
          {isMenuOpen ? "✕" : "☰"}
        </button>
      </div>
    </header>
  );
};

// ============================================================
// HomeScreen — Main landing page component
// ============================================================
export const HomeScreen = () => {
  usePreventNavigation("/");
  useScrollToTop();

  const [showMemberBlockScreen, setShowMemberBlockScreen] = useState(false);
  const { resetAssessmentData, assessmentData, updateAssessmentData, isMyRAIsActive, setIsMyRAIsActive } = useAssessment();
  const [isMicModalActive, setIsMicModalActive] = useState(false);
  const [micModalMsg, setMicModalMsg] = useState("To chat with Myra, please grant microphone access. Your audio is processed in real-time and never stored or recorded.");
  const [access, setAccess] = useState(true);
  const [isStartedLandingFlow, setIsStartedLandingFlow] = useState(false);
  const [isUserChatWithMyra, setIsUserChatWithMyra] = useState(false);
  const [isHomeVideoWatch, setIsHomeVideoWatch] = useState(false);
  const [turnNumber, setTurnNumber] = useState(0);

  // Chat A/B test state
  const [myraMode, setMyraMode] = useState(null);
  const [showChatPanel, setShowChatPanel] = useState(false);
  const [chatMessages, setChatMessages] = useState([]);
  const [chatInput, setChatInput] = useState("");
  const [isChatLoading, setIsChatLoading] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  const chatMessagesRef = useRef(null);
  const chatInputRef = useRef(null);

  // state for the video mute/unmute
  const [isMuted, setIsMuted] = useState(true);

  const [isComeFromGoogle, setIsComeFromGoogle] = useState(false);
  const [isUserCameBackAgain, setIsUserCameBackAgain] = useState(false);
  const [userCancelMic, setUserCancelMic] = useState(false);
  const [userVariant, setUserVariant] = useState(null);

  const micCancelledRef = useRef(false);

  const videoRef = useRef(null);
  const history = useHistory();
  const { search } = useLocation();

  localStorage.removeItem("startedSelf");
  const getCurrentMicState = async () => {
    if (typeof navigator !== "undefined" && navigator.permissions && navigator.permissions.query) {
      try {
        const status = await navigator.permissions.query({ name: "microphone" });
        return status.state; // 'granted' | 'denied' | 'prompt'
      } catch {
        return "prompt"; // fall back to our cached state
      }
    }
    return "prompt"; // Safari/older browsers
  };

  // use Effect to handle search step
  useEffect(() => {
    const step = new URLSearchParams(search).get("step");

    if (!step) return;

    switch (step) {
      case "askmyra":
        history.replace("/ask-myra");
        break;
      case "howitworks":
        history.replace("/how-it-works");
        break;
      case "aboutvirdio":
        history.replace("/about");
        break;
      case "startnow":
        history.replace("/problem-area");
        // stay on homescreen
        break;
      default:
        break;
    }
  }, [search, history]);

  useEffect(() => {
    if (!showChatPanel) return;
    if (showChatPanel) {
      window.VoiceService._releaseMic();
    }

    let isMounted = true;

    const checkMic = async () => {
      const state = await getCurrentMicState();
      if (!isMounted) return;

      if (state === "granted" && showChatPanel) {
        window.VoiceService._releaseMic();
      }
    };
    const interval = setInterval(checkMic, 7000);
    return () => {
      isMounted = false;
      clearInterval(interval);
    };
  }, [showChatPanel]);

  window.updateMicModalCancel = (resetValue) => {
    let updatedData = {
      ...assessmentData,
      userCancelMic: resetValue === true ? 0 : 1,
      session_last_update: new Date().toISOString(),
    };
    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);

    setUserCancelMic(resetValue === true ? false : true);

    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }
  };

  // ---- Session initialization ----
  useEffect(() => {
    MyraInteraction.onScreenEnter("landing");
    const previousSessionIdExits = window.trSessionId || localStorage.getItem("trSessionId");
    if (previousSessionIdExits) {
      localStorage.removeItem("trSessionId");
      window.trSessionId = null;
      console.log("Existing session ID found and removed:", previousSessionIdExits);
    }
    window.screenTracker.enterScreen("landing");

    // --- Repeat visitor detection ---
    const isRepeat = localStorage.getItem("isUserCameBackAgain") === "true";
    if (isRepeat) {
      setIsUserCameBackAgain(true);
    }
    localStorage.setItem("isUserCameBackAgain", "true");

    // --- URL param detection (variant / gclid) ---
    const params = new URLSearchParams(window.location.search);
    const gclid = params.get("gclid");
    const urlVariant = params.get("variant");

    // Determine variant: URL param takes priority, then localStorage (repeat visitor)
    const resolvedVariant = urlVariant || localStorage.getItem("variant") || null;

    if (urlVariant) {
      localStorage.setItem("variant", urlVariant);
    }

    const isFromGoogle = !!(gclid || resolvedVariant);

    // Update React state (still needed for trackStep payload on GSA start)
    if (resolvedVariant) setUserVariant(resolvedVariant);
    if (isFromGoogle) setIsComeFromGoogle(true);

    // --- Build tracking fields for session creation ---
    const trackingFields = {
      variant: resolvedVariant,
      isComeFromGoogle: isFromGoogle ? 1 : 0,
      isUserCameBackAgain: isRepeat ? 1 : 0,
    };

    const initializeSession = async () => {
      await AnalyticsService.startSession(trackingFields);
    };

    if (window.timeTracker) {
      window.timeTracker.startLandingTimer();
    }

    fetch("https://api64.ipify.org?format=json")
      .then((response) => {
        if (!response.ok) throw new Error("IP Service Error");
        return response.json();
      })
      .then((data) => {
        window.backupIP = data.ip;
      })
      .catch((error) => {
        console.warn("IP fetch blocked or failed (common in Incognito). Proceeding anyway.", error);
        window.backupIP = null;
      })
      .finally(() => {
        initializeSession();
      });
  }, []);

  useEffect(() => {
    window.isThisFromHomeScreen = true;
    return () => {
      window.isThisFromHomeScreen = false;
    };
  }, []);

  // ---- Myra A/B assignment — sticky via localStorage ----
  useEffect(() => {
    if (MYRA_AB_SPLIT === 50) {
      setMyraMode("equal");
    } else {
      const roll = Math.random() * 100;
      const assigned = roll < MYRA_AB_SPLIT ? "chat" : "voice";
      console.log(`AB Test Assignment - Roll: ${roll.toFixed(1)}%, Threshold: ${MYRA_AB_SPLIT}%, Assigned: ${assigned}`);
      setMyraMode("chat");
    }
  }, []);

  // ---- Video interaction tracking ----
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleVideoInteraction = () => {
      setIsHomeVideoWatch(true);
    };

    video.addEventListener("click", handleVideoInteraction);
    video.addEventListener("pause", handleVideoInteraction);
    video.addEventListener("volumechange", handleVideoInteraction);

    return () => {
      video.removeEventListener("click", handleVideoInteraction);
      video.removeEventListener("pause", handleVideoInteraction);
      video.removeEventListener("volumechange", handleVideoInteraction);
    };
  }, []);

  // ---- Myra voice interaction handler ----
  const handleMyraClick = async () => {
    // Helper: Setup the flow start callback
    const setupFlowCallback = (withMic = true) => {
      if (!window.mayraCode) return;

      window.mayraCode.setOnMicEnabled((enabledBefore) => {
        console.log("HomeScreen: Microphone enabled callback triggered, enabledBefore:", enabledBefore);
        window.mayraCode.setOnMicEnabled(null);

        const handleFlowStart = () => {
          window.mayraCode.setIsVisible(true);
          window.mayraCode.setIsFlowStarted(true);

          if (!window.trSessionId) {
            console.log("HomeScreen: No session ID found, starting new session.");
            AnalyticsService.startSession();
          }

          const checkAndStartFlow = () => {
            const isAudioReady = window.audioPlayer?.unlocked && window.audioPlayer?.ctx?.state === "running";
            if (isAudioReady) {
              window.mayraCode.startFlow("flow_landing_page");
            } else {
              console.log("HomeScreen: Audio not ready (ctx state:", window.audioPlayer?.ctx?.state, ")");
              if (window.audioPlayer?.ctx?.state === "suspended") {
                window.audioPlayer.initFromUserGesture();
              }
              setTimeout(checkAndStartFlow, 200);
            }
          };
          checkAndStartFlow();
        };
        setTimeout(handleFlowStart, 300);
      });
    };

    // Helper: Prepare UI and resources
    const prepareUI = () => {
      if (videoRef.current) {
        videoRef.current.pause();
        videoRef.current.muted = true;
        videoRef.current.volume = 0;
      }

      window.setIsMicModalActive = setIsMicModalActive;
      window.updateMyRAIsActive = setIsMyRAIsActive;

      if (window.preloadAllAudios) window.preloadAllAudios();
      if (window.videoUnlockPlay) window.videoUnlockPlay();
      if (window.mayraCode) window.mayraCode.setOnMicEnabled(null);
    };

    // Helper: Start the flow
    const startFlowSetup = () => {
      setIsStartedLandingFlow(true);
      setIsUserChatWithMyra(true);
      window.currentFlow = "flow_landing_page";
      VoiceService._currentFlow = "flow_landing_page";
      localStorage.removeItem("userCondition");

      if (window.MyraInteraction) {
        window.MyraInteraction.switchMode("voice");
      }
    };

    // Handle previously cancelled state
    if (micCancelledRef.current) {
      const granted = await window.requestMicrophonePermission({
        onGrant: () => {
          micCancelledRef.current = false;
          onGrant();
        },
        onDeny: () => {
          oncancel();
          handlePanelSwitch();
        },
      });
      return;
    }

    // Start the flow
    startFlowSetup();

    // Check if mayraCode is available
    if (!window.mayraCode) {
      console.log("mayraCode not available");
      return;
    }

    // Prepare UI and setup callback
    prepareUI();
    setupFlowCallback();

    // Request microphone permission
    const granted = await window.requestMicrophonePermission({
      onGrant: () => {
        console.log("HomeScreen: Microphone granted - starting with voice");
        setIsMyRAIsActive(true);

        if (window.mayraCode.handleHomeScreenMyraClick) {
          window.mayraCode.handleHomeScreenMyraClick(true);
        } else {
          window.mayraCode.handleMicClick(true);
        }
        onGrant();
      },
      onDeny: (reason) => {
        console.log("HomeScreen: Microphone denied - starting TTS only mode");
        setIsMyRAIsActive(true);
        oncancel();
        if (window.mayraCode.handleHomeScreenMyraClick) {
          window.mayraCode.handleHomeScreenMyraClick(true);
        } else {
          window.mayraCode.handleMicClick(false);
        }
      },
    });
  };

  const toggleMute = () => {
    setIsHomeVideoWatch(true);
    if (videoRef.current) {
      videoRef.current.muted = !isMuted;
      setIsMuted(!isMuted);
    }
  };

  // ---- Mic permission handlers ----
  const onGrant = () => {
    micCancelledRef.current = false;
    setUserCancelMic(false);
    setIsMicModalActive(false);
    if (window.updateMicModalCancel) {
      window.updateMicModalCancel(true);
    }
    if (window._myraPermissionCallbacks?.onGrant) {
      window._myraPermissionCallbacks.onGrant();
    }
    const handleMicDenied = () => {
      if (window.MyraInteraction) {
        window.MyraInteraction.switchMode("chat");
        window.MyraInteraction.closeChat();
      }
      console.log("PERMISSION DENIED - Starting flow");
      if (window.mayraCode) {
        window.mayraCode.startFlow("flow_landing_page");
        window.mayraCode.handleMicClick(true, false, false, true);
      }
      document.removeEventListener("micPermissionDenied", handleMicDenied);
    };

    document.addEventListener("micPermissionDenied", handleMicDenied);
  };

  const oncancel = () => {
    micCancelledRef.current = true;
    setIsMicModalActive(true);
    setUserCancelMic(true);
    setIsStartedLandingFlow(false);
    setIsUserChatWithMyra(false);
    setAccess(false);
    setIsMyRAIsActive(false);
    if (window.updateMicModalCancel) {
      window.updateMicModalCancel();
    }
    setMicModalMsg("Mic access is needed for Myra to hear your questions. If you prefer not to allow mic access, you can select the Chat option next to Talk. Or, start the Guided Self-Assessment anytime without asking Myra questions.");

    // let msg = "No problem! We can chat instead. I'm here if you need anything — just type or use the buttons on screen.";
    // window.mayraCode.setIsVisible(true);
    // MyraInteraction.switchMode("chat");
    // MyraInteraction.openChat();
    // MyraInteraction.pickChat();
    // MyraInteraction.onMyraMessage(msg);
  };

  // ---- Chat handlers ----
  const handleChatSend = async () => {
    const text = chatInput.trim();
    if (!text || isChatLoading) return;
    window.currentFlow = "flow_landing_page";
    VoiceService._currentFlow = "flow_landing_page";

    setChatMessages((prev) => [...prev, { role: "user", text }]);
    setChatInput("");
    setIsChatLoading(true);

    setTimeout(() => {
      if (chatMessagesRef.current) {
        chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
      }
    }, 50);

    if (!isUserChatWithMyra) {
      setIsUserChatWithMyra(true);
      setIsStartedLandingFlow(true);
    }
    let screenName = "landing";
    const screenPayload = {};

    const sessionId = window.trSessionId || localStorage.getItem("trSessionId");
    const result = await MyraChatService.sendMessage(text, sessionId, chatHistory, turnNumber, screenPayload, screenName);
    if (result) {
      setTurnNumber(result.turnNumber);
    }

    console.log("Chat result:", result);
    const hasJsonBlock = /```json[\s\S]*?```/.test(result.response);

    if (hasJsonBlock) {
      result.response = `Sorry, I didn't quite catch that. Could you say that again?`;
    }

    setChatMessages((prev) => [...prev, { role: "myra", text: result.response }]);
    setChatHistory(result.conversationHistory);
    setIsChatLoading(false);

    setTimeout(() => {
      if (chatMessagesRef.current) {
        chatMessagesRef.current.scrollTop = chatMessagesRef.current.scrollHeight;
      }
    }, 50);
  };

  const handleOpenChat = () => {
    if (window.MyraInteraction) {
      window.MyraInteraction.switchMode("chat");
    }
    VoiceService.startFlowWithoutAnnouncement("flow_landing_page");
    setIsStartedLandingFlow(true);
    setIsUserChatWithMyra(true);
    window.mayraCode.setIsVisible(true);
    if (window.VoiceService) {
      window.VoiceService._releaseMic();
    }
    let isChatSelectedBefore = MyraInteraction.wasChatSelectedBefore();
    let message = "Hi, I'm Myra — your recovery coach. I'm here to guide you through your assessment. Ask me anything, or use the buttons on screen.";

    MyraInteraction.switchMode("chat");

    MyraInteraction.pickChat();
    if (!isChatSelectedBefore) {
      MyraInteraction.onMyraMessage(message);
    }

    MyraInteraction.setChatSelectedBefore();

    // setShowChatPanel(true);
    // if (chatMessages.length === 0) {
    //   if (!isChatSelectedBefore) {
    //     setChatMessages([{ role: "myra", text: "Hi, I'm Myra — your recovery coach. I'm here to guide you through your assessment. Ask me anything, or use the buttons on screen." }]);
    //   }
    // }
    setTimeout(() => {
      if (chatInputRef.current) chatInputRef.current.focus();
    }, 100);
  };

  const handlePanelSwitch = () => {
    if (window.MyraInteraction.getMode() === "voice") {
      if (VoiceService._ws && VoiceService._ws.readyState === WebSocket.OPEN) {
        const health = VoiceService._isActuallyListening();
        if (!health.healthy) {
          VoiceService._startListening().catch((err) => console.warn("[handleSwitchMode→voice] Failed to start listening:", err));
        }
      }
    } else if (window.MyraInteraction.getMode() === "chat") {
      if (window.VoiceService) {
        window.VoiceService._releaseMic();
      }
    }
    setShowChatPanel(false);
  };

  MyraInteraction.onScreenEnter("problem_area");

  // ---- Start assessment handler ----
  const handleStartAssessment = () => {
    VoiceService.stopAllVoiceActivity();
    if (isUserChatWithMyra && window.MyraInteraction && window.MyraInteraction.getMode() !== "voice") {
      if (window.VoiceService) {
        window.VoiceService._releaseMic();
      }
    }
    resetAssessmentData();
    localStorage.removeItem("assessmentData");
    localStorage.removeItem("dataAfterInfo");
    if (!isUserChatWithMyra) {
      console.log("Didn't Started Landing Flow Removing Conditions");
      localStorage.removeItem("userCondition");
    }

    try {
      if (window.gtag) {
        window.gtag("event", "conversion", { send_to: "AW-18002481001/4AZGCNCA7YUcEOmeoIhD" });
      }
    } catch (e) {
      console.warn(e);
    }

    window.screenTracker.exitScreen("landing", {
      exitReason: "started_gsa",
      completed: true,
    });

    const finalScreenFlow = window.screenTracker.getScreenFlow();
    const timingData = window.timeTracker.startGSATimer();
    let landingDurationSec = null;
    if (finalScreenFlow.length > 0) {
      const landingScreen = finalScreenFlow.find((s) => s.screen === "landing");
      if (landingScreen && landingScreen.enteredAt && landingScreen.exitedAt) {
        const start = new Date(landingScreen.enteredAt);
        const end = new Date(landingScreen.exitedAt);
        landingDurationSec = Math.round((end - start) / 1000);
      }
    }

    const updatedData = {
      ...assessmentData,
      started_assessment: true,
      myraEngagedLanding: isUserChatWithMyra ? true : false,
      myraInteractionMode: myraMode || "unknown",
      myraChatMessagesCount: chatMessages.filter((m) => m.role === "user").length,
      homeVideoWatch: isHomeVideoWatch,
      userCancelMic: userCancelMic,
      isComeFromGoogle: isComeFromGoogle,
      isUserCameBackAgain: isUserCameBackAgain,
      variant: userVariant,
      ...timingData,
      screenFlow: finalScreenFlow,
      gsaStartedAt: timingData,
      timeOnLandingSec: landingDurationSec,
      analyticsId: window.trSessionId || localStorage.getItem("trSessionId"),
      session_last_update: new Date().toISOString(),
      EngagedOnLanding: isStartedLandingFlow ? true : false,
    };

    updateAssessmentData(updatedData);
    localStorage.setItem("assessmentData", JSON.stringify(updatedData));
    AnalyticsService.trackStep(updatedData);

    if (!window.trSessionId) {
      AnalyticsService.startSession();
    }

    history.replace("/problem-area");
  };

  // ---- Render ----
  if (showMemberBlockScreen) {
    return <BrowserBlockScreen featureType="member" />;
  }

  return (
    <div className={styles.landingPage}>
      {isMicModalActive && <LandingPageModal message={micModalMsg} onGrant={onGrant} onCancel={oncancel} isMicModalActive={isMicModalActive} setIsMicModalActive={setIsMicModalActive} access={access} setAccess={setAccess} setMicModalMsg={setMicModalMsg} />}

      <CustomHeader isStartedLandingFlow={isStartedLandingFlow} setShowMemberBlockScreen={setShowMemberBlockScreen} />

      {/* ===== HERO ===== */}
      <section className={styles.hero}>
        <div className={styles.container}>
          <div className={styles.heroInner}>
            <div className={styles.heroText}>
              <h1 className={styles.heroHeadline}>Let Myra Build Your Exercise Plan</h1>
              <p className={styles.heroSubheadline}>In about 10 minutes, Myra, Virdio Health's Recovery Coach, guides you through questions and movement checks, creates a personalized exercise plan for your pain, and explains why it's right for you.</p>

              <button className={styles.heroCta} onClick={handleStartAssessment}>
                Start My Assessment With Myra
              </button>
              <p className={styles.heroSupportLine}>Takes about 10 minutes. No credit card. No signup.</p>

              <div className={styles.trustAnchors}>
                <div className={styles.trustItem}>
                  <span className={styles.trustCheck}>✓</span>
                  <span>Tailored to your answers and movements</span>
                </div>
                <div className={styles.trustItem}>
                  <span className={styles.trustCheck}>✓</span>
                  <span>Designed for your pain, at your pace</span>
                </div>
                <div className={styles.trustItem}>
                  <span className={styles.trustCheck}>✓</span>
                  <span>Grounded in evidence-based physical therapy principles</span>
                </div>
              </div>
            </div>

            <div>
              <div className={styles.heroVideoWrap}>
                <video className={styles.heroVideo} controls autoPlay muted loop playsInline ref={videoRef}>
                  <source src={HOME_VIDEO_2} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
                <button className={styles.muteButton} onClick={toggleMute} aria-label={isMuted ? "Unmute video" : "Mute video"}>
                  {isMuted ? (
                    // Muted icon (speaker with slash)
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M11 5L6 9H2v6h4l5 4V5z" />
                      <line x1="23" y1="9" x2="17" y2="15" />
                      <line x1="17" y1="9" x2="23" y2="15" />
                    </svg>
                  ) : (
                    // Unmuted icon (speaker with sound waves)
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M11 5L6 9H2v6h4l5 4V5z" />
                      <path d="M15.54 8.46a5 5 0 0 1 0 7.07" />
                      <path d="M19.07 4.93a10 10 0 0 1 0 14.14" />
                    </svg>
                  )}
                </button>
              </div>
              <p className={styles.myraTexthowItWorks}>Want to learn more about the assessment first?</p>
              <button className={styles.myraBtnhowItWorks} onClick={() => history.push("/how-it-works")}>
                How the assessment works →
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ===== MYRA ===== */}
      <section className={styles.myraSection}>
        <div className={styles.myraBanner}>
          <div className={styles.myraInner}>
            <div className={styles.myraChatRow}>
              <div className={styles.myraAvatar}>
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                </svg>
              </div>
              <div className={styles.myraBubble}>
                <strong>Hi, I'm Myra.</strong> I'll guide you through your assessment and recovery.
              </div>
            </div>

            {/* Myra interaction — A/B test conditional rendering */}

            {/* ===== VOICE-FIRST MODE ===== */}
            {myraMode === "voice" && !showChatPanel && (
              <>
                <div className={styles.myraButtons}>
                  <button className={styles.myraBtnVoice} onClick={handleMyraClick}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                      <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                      <line x1="12" y1="19" x2="12" y2="23" />
                      <line x1="8" y1="23" x2="16" y2="23" />
                    </svg>
                    Ask Myra a Question
                  </button>
                </div>
                <button className={styles.myraSecondaryLink} onClick={handleOpenChat}>
                  Prefer to type?
                </button>
              </>
            )}

            {/* ===== CHAT-FIRST MODE ===== */}
            {myraMode === "chat" && !showChatPanel && (
              <>
                <div className={styles.myraButtons}>
                  <button className={styles.myraBtnChat} onClick={handleOpenChat}>
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                    </svg>
                    Chat with Myra
                  </button>
                </div>
                <button className={styles.myraSecondaryLink} onClick={handleMyraClick}>
                  Prefer to Speak?
                </button>
              </>
            )}

            {/* ===== EQUAL MODE (50/50) ===== */}
            {myraMode === "equal" && !showChatPanel && (
              <div className={styles.myraButtons}>
                <button className={styles.myraBtnVoice} onClick={handleMyraClick}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z" />
                    <path d="M19 10v2a7 7 0 0 1-14 0v-2" />
                    <line x1="12" y1="19" x2="12" y2="23" />
                    <line x1="8" y1="23" x2="16" y2="23" />
                  </svg>
                  Ask Myra a Question
                </button>
                <button className={styles.myraBtnChat} onClick={handleOpenChat}>
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
                  </svg>
                  Chat with Myra
                </button>
              </div>
            )}

            {/* ===== CHAT PANEL ===== */}
            {showChatPanel && (
              <div className={styles.myraChatPanel}>
                <div className={styles.myraChatMessages} ref={chatMessagesRef}>
                  {chatMessages.map((msg, i) => (
                    <div key={i} className={msg.role === "user" ? styles.chatMsgUser : styles.chatMsgMyra}>
                      {msg.text}
                    </div>
                  ))}
                  {isChatLoading && (
                    <div className={styles.chatTypingIndicator}>
                      <span />
                      <span />
                      <span />
                    </div>
                  )}
                </div>
                <div className={styles.myraChatInputRow}>
                  <input
                    ref={chatInputRef}
                    type="text"
                    className={styles.myraChatInput}
                    placeholder="Type your question…"
                    value={chatInput}
                    onChange={(e) => setChatInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") handleChatSend();
                    }}
                  />
                  <button className={styles.myraChatSendBtn} onClick={handleChatSend} disabled={isChatLoading}>
                    <svg viewBox="0 0 24 24" fill="currentColor">
                      <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                    </svg>
                  </button>
                </div>
                <button className={styles.myraSecondaryLink} onClick={handlePanelSwitch}>
                  {myraMode === "chat" ? "← Back to options" : myraMode === "voice" ? "Back to voice" : "← Back to options"}
                </button>
              </div>
            )}

            {/* Chips — visible only when chat panel is closed */}
            {!showChatPanel && (
              <div className={styles.chipsWrapper}>
                <div className={styles.chipsTrack}>
                  <div className={styles.chip}>"How long will this take?"</div>
                  <div className={styles.chip}>"Do I need to talk to a doctor before starting?"</div>
                  <div className={styles.chip}>"What happens during the assessment?"</div>
                  <div className={styles.chip}>"Does my information stay private?"</div>
                  <div className={styles.chip}>"Is the assessment really free?"</div>
                  <div className={styles.chip}>"What if I don't like it?"</div>
                  <div className={styles.chip}>"Do I need any special equipment?"</div>
                  <div className={styles.chip}>"Is this safe for my pain or condition?"</div>
                  <div className={styles.chip}>"How long will this take?"</div>
                  <div className={styles.chip}>"Do I need to talk to a doctor before starting?"</div>
                  <div className={styles.chip}>"What happens during the assessment?"</div>
                  <div className={styles.chip}>"Does my information stay private?"</div>
                  <div className={styles.chip}>"Is the assessment really free?"</div>
                  <div className={styles.chip}>"What if I don't like it?"</div>
                  <div className={styles.chip}>"Do I need any special equipment?"</div>
                  <div className={styles.chip}>"Is this safe for my pain or condition?"</div>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>

      {/* ===== WHAT YOU GET ===== */}
      <section className={styles.whatYouGet}>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <p className={styles.sectionLabel}>WHAT YOU DO AND WHAT YOU GET</p>
            <h2 className={styles.sectionTitle}>In just 10 minutes, you'll:</h2>
          </div>
          <div className={styles.whatYouGetList}>
            <div className={styles.whatYouGetItem}>
              <span className={styles.checkIcon}>✓</span>
              <div>
                <span className={styles.mainText}>Answer guided questions and complete movement checks</span>
                <span className={styles.subText}>Grounded in evidence-based physical therapy principles</span>
              </div>
            </div>

            <div className={styles.whatYouGetItem}>
              <span className={styles.checkIcon}>✓</span>
              <div>
                <span className={styles.mainText}>Get a personalized exercise plan tailored to your pain and needs</span>
                <span className={styles.subText}>Built on sound physical therapy practices</span>
              </div>
            </div>

            <div className={styles.whatYouGetItem}>
              <span className={styles.checkIcon}>✓</span>
              <div>
                <span className={styles.mainText}>Understand how each exercise is designed to help you feel better</span>
                <span className={styles.subText}>Myra explains why she chose each exercise for you</span>
              </div>
            </div>

            <div className={styles.whatYouGetItem}>
              <span className={styles.checkIcon}>✓</span>
              <div>
                <span className={styles.mainText}>Optionally ask Myra questions about your plan</span>
                <span className={styles.subText}>Your recovery, your pace</span>
                <span className={styles.subText2}>All from the comfort of your home, on your device. Free to start. No signup. No credit card required.</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ===== HOW IT WORKS ===== */}
      <section id="how-it-works" className={styles.howItWorks}>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <p className={styles.sectionLabel}>How It Works</p>
            <h2 className={styles.sectionTitle}>Your recovery starts with Myra in three simple steps.</h2>
          </div>
          <div className={styles.stepsGrid}>
            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>1</div>
              <h3 className={styles.stepTitle}>Myra guides your assessment</h3>
              <p className={styles.stepDesc}>She'll walk you through a few simple questions and gentle movement checks. No equipment, no setup — just follow her lead.</p>
            </div>
            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>2</div>
              <h3 className={styles.stepTitle}>She builds your personalized plan</h3>
              <p className={styles.stepDesc}>Based on how you move and how things feel, Myra creates a recovery plan tailored to you.</p>
            </div>
            <div className={styles.stepCard}>
              <div className={styles.stepNumber}>3</div>
              <h3 className={styles.stepTitle}>You start your first week together</h3>
              <p className={styles.stepDesc}>Myra guides each session. If something feels off, tell her and she'll adjust your plan.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== WHY TRUST MYRA ===== */}
      <section className={styles.trustSection}>
        <div className={styles.container}>
          <div className={styles.sectionHeader}>
            <p className={styles.sectionLabel}>Why Trust Myra?</p>
            <h2 className={styles.sectionTitle}>Guided, adaptive, and built around how you move.</h2>
          </div>
          <div className={styles.trustGrid}>
            <div className={styles.trustCard}>
              <div className={styles.trustCardIcon}>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
                </svg>
              </div>
              <h3 className={styles.trustCardTitle}>Built with clinical guidance</h3>
              <p className={styles.trustCardDesc}>Myra was developed with licensed physical therapists using evidence-based recovery principles.</p>
            </div>
            <div className={styles.trustCard}>
              <div className={styles.trustCardIcon}>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13 10V3L4 14h7v7l9-11h-7z" />
                </svg>
              </div>
              <h3 className={styles.trustCardTitle}>Starts at your level</h3>
              <p className={styles.trustCardDesc}>Myra learns how you move and builds your plan from there. You start where your body is today.</p>
            </div>
            <div className={styles.trustCard}>
              <div className={styles.trustCardIcon}>
                <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
                </svg>
              </div>
              <h3 className={styles.trustCardTitle}>Adapts as you recover</h3>
              <p className={styles.trustCardDesc}>As you progress, Myra adjusts. She's there with support when you need it and direction when you're unsure.</p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== FINAL CTA ===== */}
      <section className={styles.finalCta}>
        <div className={styles.container}>
          <div className={styles.finalCtaCard}>
            <h2 className={styles.finalCtaHeading}>Start your recovery today. It's free.</h2>
            <ul className={styles.finalCtaPerks}>
              <li>Myra-guided self-assessment</li>
              <li>Personalized recovery plan</li>
              <li>First week of sessions with Myra</li>
            </ul>
            <button className={styles.finalCtaBtn} onClick={handleStartAssessment}>
              Start My Assessment With Myra
            </button>
            <p className={styles.finalCtaReassurance}>No commitment. No credit card. Stop anytime.</p>
          </div>
        </div>
      </section>

      {/* ===== DISCLAIMER ===== */}
      <div className={styles.disclaimer}>
        <div className={styles.container}>
          <p className={styles.disclaimerText}>StartFreePT provides educational guidance based on your input. It is not a substitute for medical advice, diagnosis, or treatment.</p>
        </div>
      </div>

      {/* ===== FOOTER ===== */}
      <footer className={styles.footer}>
        <div className={styles.container}>
          <p className={styles.footerText}>
            © 2025 Virdio Health. All rights reserved.
            <span>v3.2.0</span>
          </p>
        </div>
      </footer>
    </div>
  );
};
